import React, { useState } from 'react';
import './App.css';
import logo from './assets/logo.jpg'; // Assuming your logo is white/gold for dark background
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFire, faBullhorn, faGlobeAmericas, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faInstagram, faFacebookF } from '@fortawesome/free-brands-svg-icons';

// Assuming your ContactButton component can accept a JSX element or object for the icon prop
// --- Translation Content ---
const translations = {
  HE: {
    tagline: "שירות גינון מכל הלב",
    description: "תחזוקת גינות - דשא סינטטי - מערכות השקיה \n אדניות בעיצוב אישי - הקמה ועוד,\nפתרונות לגינה ועבודה מכל הלב שירות אדיב מקצועי וישראלי.\nמתאים לגינות, מרפסות, גגות ואזורי משחק.",    addContact: "הוספה לאנשי קשר",
    deals: "דילים שווים, קבוצת וואטסאפ",
    status: "הסטטוס שלי-עדיין לא עובד",
    whatsapp: "וואטסאפ",
    kosherTours: "חופשות כשרות, קבוצת וואטסאפ",
    instagram: "אינסטגרם",
    facebook: "פייסבוק",
  },
  EN: {
    tagline: "Heartfelt Gardening Service",
// This is the new English description string to use in your code
description: " Planters – Landscaping and more.Garden solutions with a personal touch. Professional, courteous, and authentic Israeli service.\nPerfect for yards, balconies, rooftops, and play areas.",    addContact: "Add to Contacts",
    whatsapp: "WhatsApp",
    instagram: "Instagram",
    facebook: "FaceBook",
  },
};

// --- Language Button Component ---
function LanguageButton({ currentLang, onClick }) {
  const nextLang = currentLang === 'HE' ? 'English' : 'עברית'; 
  const nextLangCode = currentLang === 'HE' ? 'EN' : 'HE';

  return (
    <button className="language-button" onClick={() => onClick(nextLangCode)}>
      {nextLang}
    </button>
  );
}

// --- Contact Button Component ---
function ContactButton({ icon, label, link }) {
  return (
    <a className="contact-button" href={link} target="_blank" rel="noopener noreferrer">
      <div className="icon">{icon}</div>
      <div className="label">{label}</div>
    </a>
  );
}

// --- Main App Component ---
function App() {
  const [lang, setLang] = useState('HE');

  const handleLanguageChange = (newLang) => {
    setLang(newLang);
  };
  
  const T = translations[lang]; 
  const dir = lang === 'HE' ? 'rtl' : 'ltr';

  return (
    // We add the 'dark-theme' class to apply the new background style
    <div className="app-container dark-theme"> 
      {/* The actual card will be inside this container */}
      <div className="card-glass" dir={dir}> 

        <div className="header-bar">
          <LanguageButton currentLang={lang} onClick={handleLanguageChange} />
        </div>

        {/* Note: Your logo image might need to be a light color (white/gold) 
           or a transparent PNG to look good on the dark background. */}
        <img src={logo} className="logo" />

        <h2 className="tagline">{T.tagline}</h2>

        <p className="description">
          {T.description.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </p>

        <div className="buttons-grid">
          
          {/* We'll use more visible icons for the dark theme if possible */}
       {/* New implementation using Font Awesome icons */}
       <ContactButton 
        icon={<FontAwesomeIcon icon={faWhatsapp} style={{ color: '#25D366' }} />} 
        label={T.whatsapp} 
        link="https://wa.me/972522716118" 
      />
    
      <ContactButton 
        icon={<FontAwesomeIcon icon={faFacebookF} style={{ color: '#1877F2' }} />} 
        label={T.facebook} 
        link="https://www.facebook.com/share/1DnusCTBEd/" 
      />
      <ContactButton 
        icon={<FontAwesomeIcon icon={faInstagram} style={{ color: '#E1306C' }} />} 
        label={T.instagram} 
        link="https://www.instagram.com/israelbotanica/" 
      />
      
        </div>

        <a href="/Botanicacard.vcf" download className="add-contact-button">{T.addContact}</a>
      </div>
    </div>
  );
}

export default App;